import { keepPreviousData } from "@tanstack/react-query";
import { useMemo } from "react";
import { toSort } from "./sort";
import type { SortOrder } from "./sort";

type ListQueryParams = {
  page: number;
  pageSize: number;
  sortField?: string | null;
  sortOrder: SortOrder;
  filter?: string;
};

/**
 * Helper to create list query init object with consistent structure
 */
export function createListQueryInit(
  params: ListQueryParams,
  defaultSortField: string,
) {
  return useMemo(() => {
    return {
      params: {
        query: {
          page: params.page,
          pageSize: params.pageSize,
          sort: toSort(params.sortField, params.sortOrder, defaultSortField),
          filter: params.filter,
        },
      },
    } as const;
  }, [
    params.filter,
    params.page,
    params.pageSize,
    params.sortField,
    params.sortOrder,
  ]);
}

/**
 * Helper to create detail query init object with consistent structure
 */
export function createDetailQueryInit(id: string | undefined) {
  return useMemo(() => {
    return {
      params: {
        path: {
          id: id ?? "",
        },
      },
    } as const;
  }, [id]);
}


/**
 * Standard options for list queries
 */
export const listQueryOptions = {
  placeholderData: keepPreviousData,
} as const;

/**
 * Standard options for detail queries
 */
export function detailQueryOptions(enabled: boolean) {
  return {
    enabled,
  } as const;
}

